import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface IProps {
  errorText: string
  onClose?: () => void
  showCloseButton?: boolean
}

const ErrorToast: React.FC<IProps> = (props) => (
  <div className='mb-4 flex flex-row items-center gap-4 rounded-md bg-status-danger-strong p-4 text-text-on-danger'>
    {
      props.showCloseButton !== false &&
         <button
           type='button'
           aria-label='Foutmelding bericht sluiten'
           className='text-icon-on-danger'
           onClick={() => { props.onClose?.() }}
         >
           <FontAwesomeIcon
             size='lg'
             icon='times-circle'
           />
         </button>
    }

    <p className='text-text-on-danger'>{props.errorText}</p>
  </div>
)

export default ErrorToast
